import {
    UPDATE_RANGE,
    UPDATE_RANGE_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const updateRangeReducer = (state = initialState, action) => {
    switch(action.type){
        case UPDATE_RANGE:
            return {
                details: action.payload,
                success: 'Range updated successfully',
            }
        case UPDATE_RANGE_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default updateRangeReducer